// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 알림 설정 화면 */

.ap-wrap {
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1 1;
  min-height: 0;
  overflow: hidden;
  padding: 10px 14px;
}

/* ── 텔레그램 설정 박스 ── */
.ap-tg-box {
  background: #f7f9ff;
  border: 1px solid #dde2ef;
  border-radius: 6px;
  padding: 12px 16px;
  flex-shrink: 0;
}
.ap-tg-title {
  font-size: 13px;
  font-weight: 700;
  color: #1a1a2e;
  margin-bottom: 10px;
}
.ap-tg-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 7px;
}
.ap-tg-label {
  width: 70px;
  font-size: 12px;
  color: #555;
  flex-shrink: 0;
}
.ap-tg-input {
  width: 180px;
  padding: 4px 7px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 12px;
}
.ap-tg-hint {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: #666;
  margin-top: 8px;
  margin-bottom: 4px;
}
.ap-tg-pin { font-size: 13px; }
.ap-link-btn {
  background: none;
  border: none;
  color: #0066cc;
  cursor: pointer;
  font-size: 12px;
  padding: 0;
  text-decoration: underline;
}
.ap-tg-msg {
  font-size: 12px;
  margin-top: 4px;
  margin-bottom: 4px;
}
.ap-tg-msg.ok { color: #2e7d32; }
.ap-tg-msg.err { color: #c62828; }
.ap-tg-actions { margin-top: 8px; }

/* ── 수동 알림체크 행 ── */
.ap-check-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 0 4px;
}
.ap-check-btn { white-space: nowrap; flex-shrink: 0; }
.ap-check-hint { font-size: 11px; color: #888; }

/* ── 탭 ── */
.ap-tabs {
  display: flex;
  gap: 4px;
  flex-shrink: 0;
  border-bottom: 2px solid #dde2ef;
  padding-bottom: 0;
}
.ap-tab {
  padding: 7px 16px;
  font-size: 13px;
  border: 1px solid #dde2ef;
  border-bottom: none;
  background: #f7f7f7;
  cursor: pointer;
  border-radius: 4px 4px 0 0;
  color: #555;
}
.ap-tab-active {
  background: #fff;
  color: #1a1a2e;
  font-weight: 600;
  border-color: #dde2ef;
  margin-bottom: -2px;
  border-bottom: 2px solid #fff;
}

/* ── 메시지 ── */
.ap-msg {
  font-size: 12px;
  padding: 4px 10px;
  border-radius: 4px;
  flex-shrink: 0;
}
.ap-msg-success { background: #e8f5e9; color: #2e7d32; }
.ap-msg-error   { background: #ffebee; color: #c62828; }
.ap-msg-info    { background: #e3f2fd; color: #1565c0; }

/* ── 탭 바디 ── */
.ap-tab-body {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-height: 0;
  overflow: hidden;
}
.ap-tab-toolbar {
  padding: 6px 0;
  flex-shrink: 0;
}
.ap-grid-wrap {
  flex: 1 1;
  overflow: auto;
  border: 1px solid #dde2ef;
  border-radius: 4px;
}

/* ── 그리드 ── */
.ap-grid th,
.ap-grid td {
  font-size: 12px;
  white-space: nowrap;
  padding: 5px 8px;
}
.ap-threshold-cell { font-size: 11px; }
.ap-thresh-up { color: #d32f2f; margin-right: 6px; }
.ap-thresh-dn { color: #1565c0; }

/* ── 토글 스위치 ── */
.ap-toggle {
  position: relative;
  display: inline-block;
  width: 34px;
  height: 18px;
  cursor: pointer;
}
.ap-toggle input { display: none; }
.ap-toggle-slider {
  position: absolute;
  inset: 0;
  background: #ccc;
  border-radius: 18px;
  transition: background 0.2s;
}
.ap-toggle-slider::before {
  content: '';
  position: absolute;
  width: 14px;
  height: 14px;
  left: 2px;
  top: 2px;
  background: #fff;
  border-radius: 50%;
  transition: transform 0.2s;
}
.ap-toggle input:checked + .ap-toggle-slider { background: #1976d2; }
.ap-toggle input:checked + .ap-toggle-slider::before { transform: translateX(16px); }

/* ── 발송 이력 그리드 (고정 레이아웃) ── */
.ap-hist-grid {
  table-layout: fixed;
  width: 100%;
}

/* 메시지 셀: 말줄임 + 클릭 가능 */
.ap-hist-msg-cell {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
  color: #0066cc;
}
.ap-hist-msg-cell:hover { text-decoration: underline; }

/* 결과 배지 */
.ap-hist-ok         { color: #2e7d32; font-weight: 500; }
.ap-hist-fail-badge { color: #c62828; font-weight: 500; }

/* ── 페이징 ── */
.ap-paging {
  display: flex;
  gap: 4px;
  padding: 8px 0;
  flex-shrink: 0;
}
.ap-page-btn {
  padding: 3px 8px;
  border: 1px solid #ccc;
  border-radius: 3px;
  cursor: pointer;
  font-size: 12px;
  background: #fff;
}
.ap-page-btn.active {
  background: #1976d2;
  color: #fff;
  border-color: #1976d2;
}

/* ── 팝업 오버레이 ── */
.ap-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.4);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ap-popup {
  background: #fff;
  border-radius: 6px;
  width: 420px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 24px rgba(0,0,0,0.2);
}
.ap-msg-popup { width: 560px; }
.ap-popup-hd {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  font-size: 14px;
  font-weight: 600;
  background: #f0f2f8;
  border-bottom: 1px solid #dde2ef;
  border-radius: 6px 6px 0 0;
}
.ap-popup-close {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 16px;
  color: #555;
  line-height: 1;
}
.ap-popup-bd {
  padding: 14px 16px;
  overflow-y: auto;
  flex: 1 1;
}
.ap-popup-ft {
  padding: 10px 16px;
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  border-top: 1px solid #eee;
}

/* ── 폼 요소 ── */
.ap-form-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
}
.ap-form-row label:first-child {
  width: 90px;
  font-size: 12px;
  color: #444;
  flex-shrink: 0;
}
.ap-input {
  flex: 1 1;
  padding: 5px 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 12px;
}
.ap-input-sm { width: 100px; flex: none; }
.ap-input-xs { width: 60px;  flex: none; }
.ap-select {
  flex: 1 1;
  padding: 5px 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 12px;
}
.ap-select-sm { width: 80px; flex: none; }
.ap-select-xs { width: 70px; flex: none; }
.ap-unit { font-size: 12px; color: #555; }
.ap-radio-group { display: flex; gap: 12px; flex-wrap: wrap; }
.ap-radio {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  cursor: pointer;
}

/* ── 모달 모드 ── */
.ap-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.45);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ap-modal-box {
  background: #fff;
  border-radius: 8px;
  width: 780px;
  max-width: 95vw;
  height: 80vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 6px 32px rgba(0,0,0,0.25);
  overflow: hidden;
}
.ap-modal-hd {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  font-size: 15px;
  font-weight: 700;
  background: #f0f2f8;
  border-bottom: 1px solid #dde2ef;
  flex-shrink: 0;
}
.ap-modal-close {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 18px;
  color: #555;
}
.ap-modal-content {
  overflow: hidden;
  flex: 1 1;
  min-height: 0;
}

/* ── 버튼 보조 ── */
.btn-xs { padding: 2px 8px; font-size: 11px; }
.btn-danger {
  background: #fff;
  border: 1px solid #e53935;
  color: #e53935;
  border-radius: 3px;
  cursor: pointer;
}
.btn-danger:hover { background: #ffebee; }
`, "",{"version":3,"sources":["webpack://./src/pages/admin/AlertPage.css"],"names":[],"mappings":"AAAA,aAAa;;AAEb;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,eAAe;EACf,WAAW;EACX,cAAc;AAChB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;AACA,aAAa,eAAe,EAAE;AAC9B;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,UAAU;EACV,0BAA0B;AAC5B;AACA;EACE,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;AACA,gBAAgB,cAAc,EAAE;AAChC,iBAAiB,cAAc,EAAE;AACjC,iBAAiB,eAAe,EAAE;;AAElC,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;AACA,gBAAgB,mBAAmB,EAAE,cAAc,EAAE;AACrD,iBAAiB,eAAe,EAAE,WAAW,EAAE;;AAE/C,YAAY;AACZ;EACE,aAAa;EACb,QAAQ;EACR,cAAc;EACd,gCAAgC;EAChC,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,0BAA0B;EAC1B,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA,cAAc;AACd;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;AACA,kBAAkB,mBAAmB,EAAE,cAAc,EAAE;AACvD,kBAAkB,mBAAmB,EAAE,cAAc,EAAE;AACvD,kBAAkB,mBAAmB,EAAE,cAAc,EAAE;;AAEvD,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,cAAc;AAChB;AACA;EACE,SAAO;EACP,cAAc;EACd,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,cAAc;AACd;;EAEE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;AACA,qBAAqB,eAAe,EAAE;AACtC,gBAAgB,cAAc,EAAE,iBAAiB,EAAE;AACnD,gBAAgB,cAAc,EAAE;;AAEhC,iBAAiB;AACjB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;AACA,mBAAmB,aAAa,EAAE;AAClC;EACE,kBAAkB;EAClB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;AAC5B;AACA,+CAA+C,mBAAmB,EAAE;AACpE,uDAAuD,2BAA2B,EAAE;;AAEpF,8BAA8B;AAC9B;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;AACA,0BAA0B,0BAA0B,EAAE;;AAEtD,UAAU;AACV,sBAAsB,cAAc,EAAE,gBAAgB,EAAE;AACxD,sBAAsB,cAAc,EAAE,gBAAgB,EAAE;;AAExD,cAAc;AACd;EACE,aAAa;EACb,QAAQ;EACR,cAAc;EACd,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,QAAQ;EACR,2BAA2B;EAC3B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,sCAAsC;AACxC;AACA,gBAAgB,YAAY,EAAE;AAC9B;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gCAAgC;EAChC,0BAA0B;AAC5B;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,SAAO;AACT;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,eAAe;EACf,WAAW;EACX,cAAc;AAChB;AACA;EACE,SAAO;EACP,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;AACA,eAAe,YAAY,EAAE,UAAU,EAAE;AACzC,eAAe,WAAW,GAAG,UAAU,EAAE;AACzC;EACE,SAAO;EACP,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;AACA,gBAAgB,WAAW,EAAE,UAAU,EAAE;AACzC,gBAAgB,WAAW,EAAE,UAAU,EAAE;AACzC,WAAW,eAAe,EAAE,WAAW,EAAE;AACzC,kBAAkB,aAAa,EAAE,SAAS,EAAE,eAAe,EAAE;AAC7D;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,eAAe;EACf,QAAQ;EACR,4BAA4B;EAC5B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uCAAuC;EACvC,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gCAAgC;EAChC,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,SAAO;EACP,aAAa;AACf;;AAEA,gBAAgB;AAChB,UAAU,gBAAgB,EAAE,eAAe,EAAE;AAC7C;EACE,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;AACA,oBAAoB,mBAAmB,EAAE","sourcesContent":["/* 알림 설정 화면 */\n\n.ap-wrap {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n  padding: 10px 14px;\n}\n\n/* ── 텔레그램 설정 박스 ── */\n.ap-tg-box {\n  background: #f7f9ff;\n  border: 1px solid #dde2ef;\n  border-radius: 6px;\n  padding: 12px 16px;\n  flex-shrink: 0;\n}\n.ap-tg-title {\n  font-size: 13px;\n  font-weight: 700;\n  color: #1a1a2e;\n  margin-bottom: 10px;\n}\n.ap-tg-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 7px;\n}\n.ap-tg-label {\n  width: 70px;\n  font-size: 12px;\n  color: #555;\n  flex-shrink: 0;\n}\n.ap-tg-input {\n  width: 180px;\n  padding: 4px 7px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 12px;\n}\n.ap-tg-hint {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 12px;\n  color: #666;\n  margin-top: 8px;\n  margin-bottom: 4px;\n}\n.ap-tg-pin { font-size: 13px; }\n.ap-link-btn {\n  background: none;\n  border: none;\n  color: #0066cc;\n  cursor: pointer;\n  font-size: 12px;\n  padding: 0;\n  text-decoration: underline;\n}\n.ap-tg-msg {\n  font-size: 12px;\n  margin-top: 4px;\n  margin-bottom: 4px;\n}\n.ap-tg-msg.ok { color: #2e7d32; }\n.ap-tg-msg.err { color: #c62828; }\n.ap-tg-actions { margin-top: 8px; }\n\n/* ── 수동 알림체크 행 ── */\n.ap-check-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 0 4px;\n}\n.ap-check-btn { white-space: nowrap; flex-shrink: 0; }\n.ap-check-hint { font-size: 11px; color: #888; }\n\n/* ── 탭 ── */\n.ap-tabs {\n  display: flex;\n  gap: 4px;\n  flex-shrink: 0;\n  border-bottom: 2px solid #dde2ef;\n  padding-bottom: 0;\n}\n.ap-tab {\n  padding: 7px 16px;\n  font-size: 13px;\n  border: 1px solid #dde2ef;\n  border-bottom: none;\n  background: #f7f7f7;\n  cursor: pointer;\n  border-radius: 4px 4px 0 0;\n  color: #555;\n}\n.ap-tab-active {\n  background: #fff;\n  color: #1a1a2e;\n  font-weight: 600;\n  border-color: #dde2ef;\n  margin-bottom: -2px;\n  border-bottom: 2px solid #fff;\n}\n\n/* ── 메시지 ── */\n.ap-msg {\n  font-size: 12px;\n  padding: 4px 10px;\n  border-radius: 4px;\n  flex-shrink: 0;\n}\n.ap-msg-success { background: #e8f5e9; color: #2e7d32; }\n.ap-msg-error   { background: #ffebee; color: #c62828; }\n.ap-msg-info    { background: #e3f2fd; color: #1565c0; }\n\n/* ── 탭 바디 ── */\n.ap-tab-body {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n}\n.ap-tab-toolbar {\n  padding: 6px 0;\n  flex-shrink: 0;\n}\n.ap-grid-wrap {\n  flex: 1;\n  overflow: auto;\n  border: 1px solid #dde2ef;\n  border-radius: 4px;\n}\n\n/* ── 그리드 ── */\n.ap-grid th,\n.ap-grid td {\n  font-size: 12px;\n  white-space: nowrap;\n  padding: 5px 8px;\n}\n.ap-threshold-cell { font-size: 11px; }\n.ap-thresh-up { color: #d32f2f; margin-right: 6px; }\n.ap-thresh-dn { color: #1565c0; }\n\n/* ── 토글 스위치 ── */\n.ap-toggle {\n  position: relative;\n  display: inline-block;\n  width: 34px;\n  height: 18px;\n  cursor: pointer;\n}\n.ap-toggle input { display: none; }\n.ap-toggle-slider {\n  position: absolute;\n  inset: 0;\n  background: #ccc;\n  border-radius: 18px;\n  transition: background 0.2s;\n}\n.ap-toggle-slider::before {\n  content: '';\n  position: absolute;\n  width: 14px;\n  height: 14px;\n  left: 2px;\n  top: 2px;\n  background: #fff;\n  border-radius: 50%;\n  transition: transform 0.2s;\n}\n.ap-toggle input:checked + .ap-toggle-slider { background: #1976d2; }\n.ap-toggle input:checked + .ap-toggle-slider::before { transform: translateX(16px); }\n\n/* ── 발송 이력 그리드 (고정 레이아웃) ── */\n.ap-hist-grid {\n  table-layout: fixed;\n  width: 100%;\n}\n\n/* 메시지 셀: 말줄임 + 클릭 가능 */\n.ap-hist-msg-cell {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  cursor: pointer;\n  color: #0066cc;\n}\n.ap-hist-msg-cell:hover { text-decoration: underline; }\n\n/* 결과 배지 */\n.ap-hist-ok         { color: #2e7d32; font-weight: 500; }\n.ap-hist-fail-badge { color: #c62828; font-weight: 500; }\n\n/* ── 페이징 ── */\n.ap-paging {\n  display: flex;\n  gap: 4px;\n  padding: 8px 0;\n  flex-shrink: 0;\n}\n.ap-page-btn {\n  padding: 3px 8px;\n  border: 1px solid #ccc;\n  border-radius: 3px;\n  cursor: pointer;\n  font-size: 12px;\n  background: #fff;\n}\n.ap-page-btn.active {\n  background: #1976d2;\n  color: #fff;\n  border-color: #1976d2;\n}\n\n/* ── 팝업 오버레이 ── */\n.ap-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0,0,0,0.4);\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.ap-popup {\n  background: #fff;\n  border-radius: 6px;\n  width: 420px;\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 4px 24px rgba(0,0,0,0.2);\n}\n.ap-msg-popup { width: 560px; }\n.ap-popup-hd {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 16px;\n  font-size: 14px;\n  font-weight: 600;\n  background: #f0f2f8;\n  border-bottom: 1px solid #dde2ef;\n  border-radius: 6px 6px 0 0;\n}\n.ap-popup-close {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 16px;\n  color: #555;\n  line-height: 1;\n}\n.ap-popup-bd {\n  padding: 14px 16px;\n  overflow-y: auto;\n  flex: 1;\n}\n.ap-popup-ft {\n  padding: 10px 16px;\n  display: flex;\n  gap: 8px;\n  justify-content: flex-end;\n  border-top: 1px solid #eee;\n}\n\n/* ── 폼 요소 ── */\n.ap-form-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 10px;\n}\n.ap-form-row label:first-child {\n  width: 90px;\n  font-size: 12px;\n  color: #444;\n  flex-shrink: 0;\n}\n.ap-input {\n  flex: 1;\n  padding: 5px 8px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 12px;\n}\n.ap-input-sm { width: 100px; flex: none; }\n.ap-input-xs { width: 60px;  flex: none; }\n.ap-select {\n  flex: 1;\n  padding: 5px 8px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 12px;\n}\n.ap-select-sm { width: 80px; flex: none; }\n.ap-select-xs { width: 70px; flex: none; }\n.ap-unit { font-size: 12px; color: #555; }\n.ap-radio-group { display: flex; gap: 12px; flex-wrap: wrap; }\n.ap-radio {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 12px;\n  cursor: pointer;\n}\n\n/* ── 모달 모드 ── */\n.ap-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0,0,0,0.45);\n  z-index: 2000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.ap-modal-box {\n  background: #fff;\n  border-radius: 8px;\n  width: 780px;\n  max-width: 95vw;\n  height: 80vh;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 6px 32px rgba(0,0,0,0.25);\n  overflow: hidden;\n}\n.ap-modal-hd {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 16px;\n  font-size: 15px;\n  font-weight: 700;\n  background: #f0f2f8;\n  border-bottom: 1px solid #dde2ef;\n  flex-shrink: 0;\n}\n.ap-modal-close {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 18px;\n  color: #555;\n}\n.ap-modal-content {\n  overflow: hidden;\n  flex: 1;\n  min-height: 0;\n}\n\n/* ── 버튼 보조 ── */\n.btn-xs { padding: 2px 8px; font-size: 11px; }\n.btn-danger {\n  background: #fff;\n  border: 1px solid #e53935;\n  color: #e53935;\n  border-radius: 3px;\n  cursor: pointer;\n}\n.btn-danger:hover { background: #ffebee; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
